<template>
    <div class="x-html-viewer">
        <div v-html="content" @click="onClick"></div>
        <image-viewer ref="imageViewer" />
    </div>
</template>

<script>
import ImageViewer from "@/components/ImageViewer.vue";

export default {
    props: {
        content: String
    },
    components: {
        ImageViewer
    },
    mounted() {
        this.resizeImg();
    },
    methods: {
        resizeImg() {
            // 适应文档最大宽度，等比例缩放图片
            var el = this.$el,
                nodes = el.querySelectorAll("img"),
                maxWidth = el.clientWidth - 20,
                nodeMaxWidth;
            nodes.forEach(node => {
                nodeMaxWidth = maxWidth - (node.offsetLeft || 0);
                if (node.width > nodeMaxWidth) {
                    node.style.zoom = nodeMaxWidth / node.width;
                } else {
                    node.onload = function () {
                        if (node.width > nodeMaxWidth) {
                            node.style.zoom = nodeMaxWidth / node.width;
                        }
                    };
                }
            });
        },
        onClick(e) {
            if (e.target.nodeName == 'IMG') {
                this.$refs.imageViewer.setImage(e.target.src);
            }
        }
    },
};
</script>

<style>
.x-html-viewer {
    padding: 0 20px;
    background: #fff;
    position: relative;
    line-height: 1.75;
    color: rgb(57, 57, 57);
    font-size: 14px;
    font-family: "Microsoft YaHei";
    --color-bg: #f7f7f7;
    --color-hover: #fafafa;
    --color-primary: #54c7c5;
    --color-default: #222;
    --color-title: #273849;
}

.x-html-viewer img {
    cursor: zoom-in;
}

.x-html-viewer a {
    color: var(--color-primary);
}

.x-html-viewer a:hover {
    text-decoration: underline;
}

.x-html-viewer ul,
ol {
    margin: 10px 0;
    padding: 0 0 0 20px;
    font-size: 14px;
}

.x-html-viewer pre {
    padding: 0.25em 0;
    margin: 0;
    cursor: auto;
    white-space: normal;
}

.x-html-viewer .doc-block {
    background: var(--color-bg);
    padding: 8px 16px;
    border: 1px solid #ddd;
    border-radius: 3px;
    min-height: 25px;
    white-space: pre;
}

.x-html-viewer .doc-tip {
    padding: 8px 16px;
    border-radius: 4px;
    border-left: 5px solid;
    min-height: 25px;
    white-space: pre;
}

.x-html-viewer .doc-tip-info {
    background-color: #ecf8ff;
    border-left-color: var(--color-primary);
    color: var(--color-primary);
}

.x-html-viewer .doc-tip-warn {
    background-color: #fdf6ec;
    border-left-color: #e6a23c;
    color: #e6a23c;
}

.x-html-viewer .doc-tip-error {
    background-color: #fef0f0;
    border-left-color: #f56c6c;
    color: #f56c6c;
}

.x-html-viewer .doc-line {
    background-color: #ddd;
    height: 1px;
    margin: 3px 0;
}

.x-html-viewer .doc-quote {
    color: #666;
    border-left: 4px solid #ddd;
    padding-left: 20px;
    margin-left: 0;
    min-height: 25px;
}
</style>